import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Loadin } from '../components/shared';
import { UseDrawerContext, useAuthContext } from '../context';
import { Company, LocationsDan, Consolidated, ListOrganization, DetailsOrganizations, ListDam, DetailsDam, InformationDam, FeaturesUndertaking, TechnicalCharacteristicsProject, OperationRecords, InstrumentationGeotechnicalRecords, Aco, EmergencyPlan, Kpi, OrganizationChart, ListUsers, DetailsUser, Dashboard, IntrumentReading, Instruments, ListProfessionals, DetailsProfessionals, File, Files, TechnicalCharacteristicsProjectDetails, EntrepreneurInformation, MonitoringInstrumentation, AcoDetails, EmergencyPlanDetails, SemiannualInternalTrainingDetails, AnnualGuidanceSeminarDetails, EmergencySituationSimulationDetails, EmergencySituationRegisterDetails, Rise, RegisterReportsRise, Risr, RegisterReportsRisr, Rpsb, RegisterReportsRpsb, Legislation, LegislationDetails, MaintenancePlanningDetails, Psb } from '../pages';
import { DamSafetyInspectionsPlanning } from '../pages/dam/damSubPages/plansAndProcedures/legalRequirements/DamSafetyInspectionsPlanning';
import { MaintenancePlanning } from '../pages/maintenancePlanning/MaintenancePlanning';
import { EditCompany } from '../pages/company/EditCompany';
import { SemiannualInternalTraining } from '../pages/dam/damSubPages/emergencyActionPlan/legalRequirements/semiannual-internal-training/SemiannualInternalTraining';
import { AnnualGuidanceSeminar } from '../pages/dam/damSubPages/emergencyActionPlan/legalRequirements/annual-guidance-seminar/AnnualGuidanceSeminar';
import { EmergencySituationSimulation } from '../pages/dam/damSubPages/emergencyActionPlan/legalRequirements/emergency-situation-simulation/EmergencySituationSimulation';
import { EmergencySituationRegister } from '../pages/dam/damSubPages/emergencyActionPlan/legalRequirements/emergency-situation-register/EmergencySituationRegister';
import { ImportInstruments } from '../pages/instruments/ImportInstruments';
import MaintenanceChat from '../pages/maintenancePlanning/MaintenanceChat';
import Risrot from '../pages/Reports/Risrot/Risrot';


export const AppRouts = () => {

    const [ userLevel, setUserLevel ] = useState<string>('');
    const { setDrawerOptions, drawerOptions } = UseDrawerContext();
    const { userData } = useAuthContext();

    const admOptions = [
        // {
        //     label: 'Dashboard',
        //     icons: 'home',
        //     path: '/home'
        // },
        {
            label: 'Empresas',
            icons: 'business',
            path: '/companies',
        },
        {
            label: 'Unidades',
            icons: 'apartment_icon',
            path: '/company_organization',
        },
        {
            label: 'Usuarios',
            icons: 'account_circle_icon',
            path: '/users'
        },
        {
            label: 'Legislação',
            icons: 'balanceIcon',
            path: '/legislation'
        },
      
    ];

    const companyOptions = [
        {
            label: 'Dashboard',
            icons: 'home',
            path: '/home'
        },
        {
            label: 'Unidades',
            icons: 'apartment_icon',
            path: '/company_organization',
        },
        {
            label: 'Usuarios',
            icons: 'account_circle_icon',
            path: '/users'
        },
    ];

    const userOptions = [
        {
            label: 'Dashboard',
            icons: 'home',
            path: '/home'
        },
        // {
        //     label: 'Unidades',
        //     icons: 'apartment_icon',
        //     path: '/company_organization',
        // },
    ];

    const fetchData = () => {
        const verifyAccess = async () => {
            try {
                if (userData) {                    
                    if (userData.nivel === 'user') {
                        setUserLevel('user');
                        setDrawerOptions(userOptions);
                    } else if (userData.nivel === 'adm') {
                        setDrawerOptions(admOptions);
                        setUserLevel('adm');
                    } else {
                        setUserLevel('empresa');
                        setDrawerOptions(companyOptions);
                    }
                }                                  
                                
            } catch (error) {
                console.log('Error:', error);
            }
        };

        verifyAccess();
    };

    useEffect(() => {
        fetchData();
    }, [userData]);

    if (drawerOptions.length === 0) {
        return(
           <Loadin />
        );
    }  
   
    switch(userLevel){
        case 'adm':
            return(
                <Routes>
                {/* Barragem */}
                <Route path='/companies' element={<Company />} />
                {/* <Route path='/home' element={<Dashboard />} /> */}
                <Route path='/information_dam/:id' element={<InformationDam/>} />
                {/* Users */}
                <Route path='/users' element={<ListUsers/>} />
                {/* <Route path='/users/:id/detalhes/:user' element={<DetailsUser/>} /> */}
                <Route path='/users/detalhes/:id' element={<DetailsUser/>} />

                {/* Company */}
                <Route path='/companies/company_registration/:id' element={<EditCompany />} />
                <Route path='/company_dam/detalhes/:uuid' element={<DetailsDam/>} />
                {/* Organization */}
                <Route path='/company_organization' element={<ListOrganization/>} />
                <Route path='/company_organization/detalhes/:id' element={<DetailsOrganizations/>} />
                {/* Dam */}
                <Route path='/company_dam/:id' element={<ListDam/>} />
                <Route path='/company_dam/:org/detalhes/:uuid' element={<DetailsDam/>} />
                <Route path='/information_dam/:id/kpi' element={<Kpi/>}/>
                <Route path='/information_dam/:dam/entrepreneu_id' element={<EntrepreneurInformation />} />
                <Route path='/information_dam/:id/features-undertaking' element={<FeaturesUndertaking />} />
                {/* OrganizationChart */}
                <Route path='/information_dam/:id/organization_chart' element={<OrganizationChart/>} />
                <Route path='/information_dam/:id/organization_chart/professionals' element={<ListProfessionals/>} />
                <Route path='/information_dam/:id/organization_chart/professionals/:uuid' element={<DetailsProfessionals/>} />
                {/* technical_characteristics_project */}
                <Route path='/information_dam/:dam/technical_characteristics_project' element={<TechnicalCharacteristicsProject/>} />
                <Route path='/information_dam/:dam/technical_characteristics_project/:project' element={<TechnicalCharacteristicsProjectDetails/>} />
                {/* Files */}
                <Route path='/information_dam/:id/files/:type' element={<Files/>} />
                <Route path='/information_dam/:dam/files/:type/:file' element={<File/>}/>
                {/* maintenance_planning */}
                <Route path='/information_dam/:id/maintenance_planning' element={<MaintenancePlanning/>}/>
                <Route path='/information_dam/:id/maintenance_planning/:maintenance' element={<MaintenancePlanningDetails/>}/>
                <Route path='/information_dam/:id/maintenance_planning/:maintenance/chat' element={<MaintenanceChat/>}/>

                <Route path='/information_dam/:dam/monitoring_instrumentation_plan' element={<MonitoringInstrumentation/>}/>
                {/* Instruments */}
                <Route path='/information_dam/:dam/instrument/:uuid' element={<Instruments/>} />
                <Route path='/information_dam/:id/instrumentation_geotechnical_records' element={<InstrumentationGeotechnicalRecords/>}/>
                <Route path='/information_dam/:id/instrument_reading/import' element={<ImportInstruments/>}/>
                <Route path='/information_dam/:id/instrument_reading' element={<IntrumentReading/>} />
                <Route path='/information_dam/:id/instrument_reading/:uuid/:instrumento' element={<IntrumentReading/>} />

                {/* dam_safety_inspections_planning */}
                <Route path='/information_dam/:id/dam_safety_inspections_planning' element={<DamSafetyInspectionsPlanning/>}/>
                {/* Reporst */}
                <Route path='/information_dam/:id/rise' element={<Rise/>}/>
                <Route path='/information_dam/:id/rise/:rise' element={<RegisterReportsRise/>}/>
                <Route path='/information_dam/:id/risr' element={<Risr/>}/>
                <Route path='/information_dam/:id/risr/:risr' element={<RegisterReportsRisr/>}/>
                <Route path='/information_dam/:id/rpsb' element={<Rpsb/>}/>
                <Route path='/information_dam/:id/rpsb/:rpsb' element={<RegisterReportsRpsb/>}/>
                {/* operation_records */}
                <Route path='/information_dam/:id/operation_records' element={<OperationRecords/>}/>
                {/* Actions Plans */}
                <Route path='/information_dam/:id/emergency_plan' element={<EmergencyPlan/>}/>
                <Route path='/information_dam/:id/emergency_plan/detalhes/:actionId' element={<EmergencyPlanDetails/>}/>
                <Route path='/information_dam/:id/aco' element={<Aco/>}/>
                <Route path='/information_dam/:id/aco/detalhes/:idAco' element={<AcoDetails/>}/>
                <Route path='/information_dam/:id/semiannual_internal_training' element={<SemiannualInternalTraining/>}/>
                <Route path='/information_dam/:id/semiannual_internal_training/detalhes/:idTraining' element={<SemiannualInternalTrainingDetails/>}/>
                <Route path='/information_dam/:id/annual_guidance_seminar' element={<AnnualGuidanceSeminar/>}/>
                <Route path='/information_dam/:id/annual_guidance_seminar/detalhes/:idSeminar' element={<AnnualGuidanceSeminarDetails/>}/>
                <Route path='/information_dam/:id/emergency_situation_simulation' element={<EmergencySituationSimulation/>}/>
                <Route path='/information_dam/:id/emergency_situation_simulation/detalhes/:idEmergecy' element={<EmergencySituationSimulationDetails/>}/>
                <Route path='/information_dam/:id/emergency_situation_register' element={<EmergencySituationRegister/>}/>
                <Route path='/information_dam/:id/emergency_situation_register/detalhes/:idRegister' element={<EmergencySituationRegisterDetails/>}/>
                {/* Up bar */}
                <Route path='/locations' element={<LocationsDan />} />
                <Route path='/consolidated' element={<Consolidated />} />

                <Route path='/legislation' element={<Legislation />} />
                <Route path='/legislation/:id' element={<LegislationDetails />} />

                <Route path='*' element={<Navigate to='/companies'/>} />
            </Routes>
        );
        case 'empresa':
            return(
                <Routes>
                {/* Barragem */}
                <Route path='/home' element={<Dashboard />} />
                <Route path='/information_dam/:id' element={<InformationDam/>} />
                {/* Users */}
                <Route path='/users' element={<ListUsers/>} />
                <Route path='/users/detalhes/:id' element={<DetailsUser/>} />
                {/* Organization */}
                <Route path='/company_organization' element={<ListOrganization/>} />
                <Route path='/company_organization/detalhes/:id' element={<DetailsOrganizations/>} />
                {/* Dam */}
                <Route path='/company_dam/:id' element={<ListDam/>} />
                <Route path='/company_dam/:org/detalhes/:uuid' element={<DetailsDam/>} />
                <Route path='/information_dam/:id/kpi' element={<Kpi/>}/>
                <Route path='/information_dam/:dam/entrepreneu_id' element={<EntrepreneurInformation />} />
                <Route path='/information_dam/:id/features-undertaking' element={<FeaturesUndertaking />} />
                {/* OrganizationChart */}
                <Route path='/information_dam/:id/organization_chart' element={<OrganizationChart/>} />
                <Route path='/information_dam/:id/organization_chart/professionals' element={<ListProfessionals/>} />
                <Route path='/information_dam/:id/organization_chart/professionals/:uuid' element={<DetailsProfessionals/>} />
                {/* technical_characteristics_project */}
                <Route path='/information_dam/:dam/technical_characteristics_project' element={<TechnicalCharacteristicsProject/>} />
                <Route path='/information_dam/:dam/technical_characteristics_project/:project' element={<TechnicalCharacteristicsProjectDetails/>} />
                {/* Files */}
                <Route path='/information_dam/:id/files/:type' element={<Files/>} />
                <Route path='/information_dam/:dam/files/:type/:file' element={<File/>}/>
                {/* maintenance_planning */}
                <Route path='/information_dam/:id/maintenance_planning' element={<MaintenancePlanning/>}/>
                <Route path='/information_dam/:id/maintenance_planning/:maintenance' element={<MaintenancePlanningDetails/>}/>
                <Route path='/information_dam/:id/maintenance_planning/:maintenance/chat' element={<MaintenanceChat/>}/>
                <Route path='/information_dam/:dam/monitoring_instrumentation_plan' element={<MonitoringInstrumentation/>}/>
                {/* Instruments */}
                <Route path='/information_dam/:dam/instrument/:uuid' element={<Instruments/>} />
                <Route path='/information_dam/:id/instrumentation_geotechnical_records' element={<InstrumentationGeotechnicalRecords/>}/>
                <Route path='/information_dam/:id/instrument_reading/import' element={<ImportInstruments/>}/>
                <Route path='/information_dam/:id/instrument_reading' element={<IntrumentReading/>} />
                <Route path='/information_dam/:id/instrument_reading/:uuid/:instrumento' element={<IntrumentReading/>} />
                {/* dam_safety_inspections_planning */}
                <Route path='/information_dam/:id/dam_safety_inspections_planning' element={<DamSafetyInspectionsPlanning/>}/>
                {/* Reporst */}
                <Route path='/information_dam/:id/rise' element={<Rise/>}/>
                <Route path='/information_dam/:id/rise/:rise' element={<RegisterReportsRise/>}/>
                <Route path='/information_dam/:id/risr' element={<Risr/>}/>
                <Route path='/information_dam/:id/risr/:risr' element={<RegisterReportsRisr/>}/>
                <Route path='/information_dam/:id/rpsb' element={<Rpsb/>}/>
                <Route path='/information_dam/:id/rpsb/:rpsb' element={<RegisterReportsRpsb/>}/>
                <Route path='/information_dam/:id/risrot' element={<Risrot />} />
                {/* operation_records */}
                <Route path='/information_dam/:id/operation_records' element={<OperationRecords/>}/>
                {/* Actions Plans */}
                <Route path='/information_dam/:id/emergency_plan' element={<EmergencyPlan/>}/>
                <Route path='/information_dam/:id/emergency_plan/detalhes/:actionId' element={<EmergencyPlanDetails/>}/>
                <Route path='/information_dam/:id/aco' element={<Aco/>}/>
                <Route path='/information_dam/:id/aco/detalhes/:idAco' element={<AcoDetails/>}/>
                <Route path='/information_dam/:id/semiannual_internal_training' element={<SemiannualInternalTraining/>}/>
                <Route path='/information_dam/:id/semiannual_internal_training/detalhes/:idTraining' element={<SemiannualInternalTrainingDetails/>}/>
                <Route path='/information_dam/:id/annual_guidance_seminar' element={<AnnualGuidanceSeminar/>}/>
                <Route path='/information_dam/:id/annual_guidance_seminar/detalhes/:idSeminar' element={<AnnualGuidanceSeminarDetails/>}/>
                <Route path='/information_dam/:id/emergency_situation_simulation' element={<EmergencySituationSimulation/>}/>
                <Route path='/information_dam/:id/emergency_situation_simulation/detalhes/:idEmergecy' element={<EmergencySituationSimulationDetails/>}/>
                <Route path='/information_dam/:id/emergency_situation_register' element={<EmergencySituationRegister/>}/>
                <Route path='/information_dam/:id/emergency_situation_register/detalhes/:idRegister' element={<EmergencySituationRegisterDetails/>}/>
                {/* Up bar */}
                <Route path='/locations' element={<LocationsDan />} />
                <Route path='/consolidated' element={<Consolidated />} />
                {/* Legislação */}
                <Route path='/legislation' element={<Legislation />} />
                <Route path='/legislation/:id' element={<LegislationDetails />} />

                <Route path='*' element={<Navigate to='/home'/>} />


                {/* psb */}
                <Route path='/information_dam/:id/psb' element={<Psb />} />
            </Routes>
        );
        case 'user':
            return(
                <Routes>
                {/* Barragem */}
                <Route path='/home' element={<Dashboard />} />
                <Route path='/information_dam/:id' element={<InformationDam/>} />
                {/* Dam */}
                <Route path='/company_dam/:id' element={<ListDam/>} />
                <Route path='/company_dam/:org/detalhes/:uuid' element={<DetailsDam/>} />
                <Route path='/information_dam/:id/kpi' element={<Kpi/>}/>
                <Route path='/information_dam/:dam/entrepreneu_id' element={<EntrepreneurInformation />} />
                <Route path='/information_dam/:id/features-undertaking' element={<FeaturesUndertaking />} />
                {/* OrganizationChart */}
                <Route path='/information_dam/:id/organization_chart' element={<OrganizationChart/>} />
                <Route path='/information_dam/:id/organization_chart/professionals' element={<ListProfessionals/>} />
                <Route path='/information_dam/:id/organization_chart/professionals/:uuid' element={<DetailsProfessionals/>} />
                {/* technical_characteristics_project */}
                <Route path='/information_dam/:dam/technical_characteristics_project' element={<TechnicalCharacteristicsProject/>} />
                <Route path='/information_dam/:dam/technical_characteristics_project/:project' element={<TechnicalCharacteristicsProjectDetails/>} />
                {/* Files */}
                <Route path='/information_dam/:id/files/:type' element={<Files/>} />
                <Route path='/information_dam/:dam/files/:type/:file' element={<File/>}/>
                {/* maintenance_planning */}
                <Route path='/information_dam/:id/maintenance_planning' element={<MaintenancePlanning/>}/>
                <Route path='/information_dam/:id/maintenance_planning/:maintenance' element={<MaintenancePlanningDetails/>}/>
                <Route path='/information_dam/:id/maintenance_planning/:maintenance/chat' element={<MaintenanceChat/>}/>
                <Route path='/information_dam/:dam/monitoring_instrumentation_plan' element={<MonitoringInstrumentation/>}/>
                {/* Instruments */}
                <Route path='/information_dam/:dam/instrument/:uuid' element={<Instruments/>} />
                <Route path='/information_dam/:id/instrumentation_geotechnical_records' element={<InstrumentationGeotechnicalRecords/>}/>
                <Route path='/information_dam/:id/instrument_reading/import' element={<ImportInstruments/>}/>
                <Route path='/information_dam/:id/instrument_reading' element={<IntrumentReading/>} />
                <Route path='/information_dam/:id/instrument_reading/:uuid/:instrumento' element={<IntrumentReading/>} />
                {/* dam_safety_inspections_planning */}
                <Route path='/information_dam/:id/dam_safety_inspections_planning' element={<DamSafetyInspectionsPlanning/>}/>
                {/* Reporst */}
                <Route path='/information_dam/:id/rise' element={<Rise/>}/>
                <Route path='/information_dam/:id/rise/:rise' element={<RegisterReportsRise/>}/>
                <Route path='/information_dam/:id/risr' element={<Risr/>}/>
                <Route path='/information_dam/:id/risr/:risr' element={<RegisterReportsRisr/>}/>
                <Route path='/information_dam/:id/rpsb' element={<Rpsb/>}/>
                <Route path='/information_dam/:id/rpsb/:rpsb' element={<RegisterReportsRpsb/>}/>
                {/* operation_records */}
                <Route path='/information_dam/:id/operation_records' element={<OperationRecords/>}/>
                {/* Actions Plans */}
                <Route path='/information_dam/:id/emergency_plan' element={<EmergencyPlan/>}/>
                <Route path='/information_dam/:id/emergency_plan/detalhes/:actionId' element={<EmergencyPlanDetails/>}/>
                <Route path='/information_dam/:id/aco' element={<Aco/>}/>
                <Route path='/information_dam/:id/aco/detalhes/:idAco' element={<AcoDetails/>}/>
                <Route path='/information_dam/:id/semiannual_internal_training' element={<SemiannualInternalTraining/>}/>
                <Route path='/information_dam/:id/semiannual_internal_training/detalhes/:idTraining' element={<SemiannualInternalTrainingDetails/>}/>
                <Route path='/information_dam/:id/annual_guidance_seminar' element={<AnnualGuidanceSeminar/>}/>
                <Route path='/information_dam/:id/annual_guidance_seminar/detalhes/:idSeminar' element={<AnnualGuidanceSeminarDetails/>}/>
                <Route path='/information_dam/:id/emergency_situation_simulation' element={<EmergencySituationSimulation/>}/>
                <Route path='/information_dam/:id/emergency_situation_simulation/detalhes/:idEmergecy' element={<EmergencySituationSimulationDetails/>}/>
                <Route path='/information_dam/:id/emergency_situation_register' element={<EmergencySituationRegister/>}/>
                <Route path='/information_dam/:id/emergency_situation_register/detalhes/:idRegister' element={<EmergencySituationRegisterDetails/>}/>
                {/* Up bar */}
                <Route path='/locations' element={<LocationsDan />} />
                <Route path='/consolidated' element={<Consolidated />} />
                {/* Legislação */}
                <Route path='/legislation' element={<Legislation />} />
                <Route path='/legislation/:id' element={<LegislationDetails />} />

                <Route path='*' element={<Navigate to='/home'/>} />
            </Routes>
        );
        default:
            return(
                <Routes>
                    <Route path='*' element={<Navigate to='/home'/>} />
                </Routes>
            );
    }
};

